import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AvailabilityService } from 'src/app/services/availability.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { Store } from 'src/app/store';

@Component({
    selector: 'app-availability-additional-nights',
    templateUrl: './availability-additional-nights.component.html',
    styleUrls: ['./availability-additional-nights.component.css']
})
export class AvailabilityAdditionalNightsComponent implements OnInit {
    @Input() ratePlan;
    @Output() emitResult = new EventEmitter;


    av = undefined;
    b = undefined;
    rp = undefined;

    options = [];
    errorText = '';

    constructor(
        private availabilityService: AvailabilityService,
        private overlayService: OverlayService,
        private store: Store,
    ) { }

    ngOnInit(): void {
        this.av = { ...this.store.selectForLocal('availabilitySearch') };
        this.b = { ...this.store.selectForLocal('basketBooking') };
        this.loadAdditionalNightRates();
    }

    loadAdditionalNightRates() {
        this.av.nights = +this.av.nights + 1;
        this.availabilityService.loadAdditionalNightRates(this.av, this.b.planSelected.ratePlanCode).subscribe(data => {
            console.log(data);
            if (data.ratePlans.length) {
                this.rp = data.ratePlans[0]
                this.options = this.rp.optionsChoice
                    .split(',')
                    .map(option => ({
                        text: option.trim(),
                        selected: false
                    }));
            }
        })
    }

    toggleOptionSelected(idx) {
        this.errorText = ''
        if (!this.options[idx].selected) {
            this.options[idx].selected = true;
        } else {
            this.options[idx].selected = true;
        }
        this.options.forEach((e, i) => {
            if (i !== idx) {
                e.selected = false;
            }
        })
    }

    canContinue() {
        if (!this.options.length) {
            return true;
        }

        const hasSelected = this.options.some(e => e.selected);

        if (hasSelected) {
            console.log('FOUND AN OPTION');
            return true;
        }

        console.log('NOT FOUND AN OPTION');
        return false;
    }

    close() {
        // this.store.set('infoPlan', undefined);
        this.emitResult.emit();
        // this.overlayService.toggle('additionalNights', false);
    }

    cancel() {
        this.errorText = ''
        // this.store.set('infoPlan', undefined);
        this.emitResult.emit({ 'accepted': false });
        // this.overlayService.toggle('additionalNights', false);
    }
    accept() {
        this.errorText = ''
        // this.store.set('infoPlan', undefined);
        this.av.nightsToStay = [];
        for (let n = 0; n < this.rp.nights.length; n++) {
            this.av.nightsToStay.push({ available: true, checkInDay: this.rp.nights[n].checkInDay })
        }
        this.emitResult.emit({ 'accepted': true, rp: this.rp, av: this.av });
        // this.overlayService.toggle('additionalNights', false);
    }

}
